// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
// VYLAPP — All remaining page and modal components
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
import { useState, useEffect, useRef } from "react";
import { Avatar, LiveBadge, VybePill, Ic, ICONS, TranslateToggle } from "./UI.jsx";
import { useAuthStore, useChatStore, useSpacesStore, useUIStore } from "../context/store.js";
import { getSocket } from "../hooks/useSocket.js";
import api from "../api/client.js";

const B = {
  bg:"#08070F",bg2:"#0D0C18",bg3:"#131124",
  violet:"#7C3AED",violetLt:"#8B5CF6",
  violetDim:"rgba(124,58,237,0.15)",violetBorder:"rgba(124,58,237,0.3)",
  vibeGreen:"#10F5A0",vibeGreenDim:"rgba(16,245,160,0.12)",vibeGreenBorder:"rgba(16,245,160,0.25)",
  coral:"#FF6B6B",coralDim:"rgba(255,107,107,0.12)",coralBorder:"rgba(255,107,107,0.28)",
  amber:"#FFB830",sky:"#38BDF8",skyDim:"rgba(56,189,248,0.12)",
  purple:"#A78BFA",purpleDim:"rgba(167,139,250,0.12)",teal:"#2DD4BF",
  text:"#F0EFFE",text2:"#7C7A9E",text3:"#3D3B5C",
  border:"rgba(124,58,237,0.15)",border2:"rgba(124,58,237,0.08)",
  grad:"linear-gradient(135deg,#7C3AED,#10F5A0)",gradCoral:"linear-gradient(135deg,#7C3AED,#FF6B6B)",
  font:"'Sora',system-ui,sans-serif",mono:"'Space Mono',monospace",
};
const fmt = s=>`${String(Math.floor(s/60)).padStart(2,"0")}:${String(s%60).padStart(2,"0")}`;
const numFmt = n=>!n?"0":n>=1000?`${(n/1000).toFixed(1)}k`:String(n);

// ── RightBar ──────────────────────────────────────────────────────────────────
export function RightBar({ onCall }) {
  const [trending, setTrending] = useState([
    {cat:"Tech Vibes",tag:"#DAOs",count:"847 vibes"},
    {cat:"Global",tag:"#AgriTech10k",count:"2.9k vibes"},
    {cat:"Creative",tag:"#ClimateArt",count:"1.3k vibes"},
    {cat:"Learning",tag:"#SecondBrain",count:"634 vibes"},
  ]);
  const [suggestions, setSuggestions] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/users/suggestions/connect").then(r => setSuggestions(r.data)).catch(()=>{});
  }, []);

  return (
    <div style={{ width:340, padding:"0 16px", overflowY:"auto", flexShrink:0 }}>
      <div style={{ display:"flex", alignItems:"center", gap:10, background:B.bg3, borderRadius:12, padding:"10px 16px", margin:"12px 0", border:`1px solid ${B.border2}` }}>
        <Ic d={ICONS.search} s={18} c={B.text2} />
        <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Search Vylapp"
          style={{ flex:1, background:"none", border:"none", color:B.text, fontFamily:B.font, fontSize:15, outline:"none" }} />
      </div>
      <div style={{ background:B.bg3, borderRadius:16, overflow:"hidden", marginBottom:12, border:`1px solid ${B.border2}` }}>
        <div style={{ fontWeight:900, fontSize:18, padding:"14px 16px 8px", color:B.text }}>Trending Vibes</div>
        {trending.map((t,i) => (
          <div key={i} style={{ padding:"10px 16px", cursor:"pointer", borderTop:`1px solid ${B.border2}` }}
            onMouseEnter={e=>e.currentTarget.style.background=B.violetDim}
            onMouseLeave={e=>e.currentTarget.style.background="none"}>
            <div style={{ fontSize:12, color:B.text2, fontFamily:B.mono }}>{t.cat} · Trending</div>
            <div style={{ fontWeight:700, fontSize:15, color:B.text, margin:"2px 0" }}>{t.tag}</div>
            <div style={{ fontSize:12, color:B.text2, fontFamily:B.mono }}>{t.count}</div>
          </div>
        ))}
      </div>
      <div style={{ background:B.bg3, borderRadius:16, overflow:"hidden", marginBottom:12, border:`1px solid ${B.border2}` }}>
        <div style={{ fontWeight:900, fontSize:18, padding:"14px 16px 8px", color:B.text }}>Vibers to Connect</div>
        {suggestions.slice(0,4).map((u,i) => (
          <div key={i} style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 16px", borderTop:`1px solid ${B.border2}` }}
            onMouseEnter={e=>e.currentTarget.style.background=B.violetDim}
            onMouseLeave={e=>e.currentTarget.style.background="none"}>
            <Avatar user={u} size={40} showOnline />
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ display:"flex", gap:4 }}>
                <span style={{ fontWeight:700, fontSize:14, color:B.text }}>{u.displayName}</span>
                {u.verified && <span style={{ color:B.violet, fontSize:13 }}>✓</span>}
              </div>
              <div style={{ fontSize:12, color:B.text2 }}>{u.role}</div>
            </div>
            <ConnectBtn userId={u._id} />
          </div>
        ))}
      </div>
      <div style={{ fontSize:12, color:B.text3, padding:"4px 4px 16px", lineHeight:2 }}>
        Terms · Privacy · © 2026 Vylapp Inc.
      </div>
    </div>
  );
}

function ConnectBtn({ userId }) {
  const [connected, setConnected] = useState(false);
  const handleConnect = async () => {
    setConnected(v => !v);
    try { await api.post(`/users/${userId}/follow`); } catch {}
  };
  return (
    <button onClick={handleConnect} style={{
      padding:"6px 14px", borderRadius:9999, fontWeight:700, fontSize:13, cursor:"pointer",
      fontFamily:B.font, transition:"all 0.2s", flexShrink:0,
      background: connected ? "transparent" : B.grad,
      color: connected ? B.text : "#fff",
      border: connected ? `1px solid ${B.border}` : "none",
      boxShadow: connected ? "none" : "0 4px 14px rgba(124,58,237,0.3)",
    }}>{connected ? "Connected ✓" : "Connect"}</button>
  );
}

// ── CallModal ─────────────────────────────────────────────────────────────────
export function CallModal({ call, onClose }) {
  const [micOn,    setMicOn]    = useState(true);
  const [camOn,    setCamOn]    = useState(call.type==="video");
  const [screenOn, setScreenOn] = useState(false);
  const [recOn,    setRecOn]    = useState(false);
  const [transOn,  setTransOn]  = useState(false);
  const [transLang, setTransLang] = useState("Spanish");
  const [secs,     setSecs]     = useState(0);
  const [recSecs,  setRecSecs]  = useState(0);
  const [transcript, setTranscript] = useState([
    { speaker: call.user?.displayName||"Participant", text:"Hey, can you hear me clearly?" },
    { speaker:"You", text:"Crystal clear! Loving Vylapp Connect 💚" },
  ]);
  const captions = ["Building the future together 🌱","El aspecto comunitario es clave","Construyendo el futuro juntos","Progreso increíble"];
  const [capIdx, setCapIdx] = useState(0);

  useEffect(()=>{ const t=setInterval(()=>setSecs(s=>s+1),1000); return()=>clearInterval(t); },[]);
  useEffect(()=>{ if(!recOn){setRecSecs(0);return;} const t=setInterval(()=>setRecSecs(s=>s+1),1000); return()=>clearInterval(t); },[recOn]);
  useEffect(()=>{
    if(!transOn)return;
    const lines=[{text:"Building the future 🌱",translated:"Construyendo el futuro 🌱"},{text:"Community is everything",translated:"La comunidad es todo"}];
    const t=setInterval(()=>{
      const l=lines[Math.floor(Math.random()*lines.length)];
      setTranscript(prev=>[...prev.slice(-5),{speaker:"Speaker",text:l.text,translated:l.translated}]);
      setCapIdx(c=>c+1);
    },3000);
    return()=>clearInterval(t);
  },[transOn]);

  const Ctrl=({icon,label,active,onToggle,color})=>(
    <button onClick={onToggle} style={{ display:"flex",flexDirection:"column",alignItems:"center",gap:4,padding:"10px 14px",borderRadius:12,border:active?`1px solid ${color}30`:"1px solid transparent",cursor:"pointer",background:active?`${color}18`:"rgba(255,255,255,0.04)",color:active?color:B.text2,fontFamily:B.font,fontSize:10,letterSpacing:0.4,transition:"all 0.15s" }}>
      <Ic d={icon} s={20} c={active?color:B.text2} />{label}
    </button>
  );

  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(8,7,15,0.92)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(24px)" }}>
      <div style={{ width:"min(860px,95vw)",background:B.bg2,borderRadius:20,border:`1px solid ${B.border}`,overflow:"hidden",boxShadow:`0 40px 120px rgba(124,58,237,0.3)` }}>
        <div style={{ height:2, background:B.grad }} />
        <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 20px",borderBottom:`1px solid ${B.border2}` }}>
          <div style={{ display:"flex",alignItems:"center",gap:10 }}>
            <Ic d={call.type==="video"?ICONS.video:ICONS.phone} s={16} c={B.violetLt} />
            <span style={{ color:B.text,fontWeight:700,fontSize:15 }}>{call.type==="video"?"Video Connect":"Voice Connect"} — {call.user?.displayName||"Friend"}</span>
            {recOn&&<LiveBadge />}
          </div>
          <div style={{ display:"flex",alignItems:"center",gap:12 }}>
            <span style={{ color:B.vibeGreen,fontFamily:B.mono,fontSize:14,background:B.vibeGreenDim,padding:"3px 10px",borderRadius:6,border:`1px solid ${B.vibeGreenBorder}` }}>{fmt(secs)}</span>
            <TranslateToggle on={transOn} onToggle={()=>setTransOn(v=>!v)} lang={transLang} onLang={setTransLang} />
          </div>
        </div>
        <div style={{ display:"flex",height:400 }}>
          <div style={{ flex:1,display:"flex",flexDirection:"column" }}>
            <div style={{ flex:1,background:`linear-gradient(135deg,${B.bg},#0d0c1f)`,display:"flex",alignItems:"center",justifyContent:"center",position:"relative" }}>
              <div style={{ textAlign:"center" }}>
                <Avatar user={call.user||{displayName:"Friend",initials:"FR",color:B.vibeGreen}} size={72} ring />
                <div style={{ color:B.text,fontWeight:700,fontSize:15,marginTop:10 }}>{call.user?.displayName||"Friend"}</div>
                <div style={{ color:B.text2,fontSize:12,marginTop:4 }}>Connected on Vylapp</div>
              </div>
              {transOn&&<div style={{ position:"absolute",bottom:12,left:12,right:12,background:"rgba(8,7,15,0.9)",borderRadius:10,padding:"10px 14px",borderTop:`2px solid ${B.violet}` }}>
                <div style={{ color:B.text2,fontSize:10,letterSpacing:1,fontFamily:B.mono }}>LIVE → {transLang}</div>
                <div style={{ color:B.violetLt,fontSize:13,marginTop:2 }}>{captions[capIdx%captions.length]}</div>
              </div>}
            </div>
            <div style={{ height:90,display:"grid",gridTemplateColumns:"1fr 1fr",gap:2,background:B.bg }}>
              <div style={{ background:B.bg3,display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:4 }}>
                <Avatar user={useAuthStore.getState().user||{initials:"YO",color:B.vibeGreen}} size={32} ring />
                <span style={{ color:B.text2,fontSize:10,fontFamily:B.mono }}>You{screenOn?" · Sharing":""}</span>
              </div>
              <div style={{ background:B.bg2,display:"flex",alignItems:"center",justifyContent:"center" }}>
                <span style={{ color:B.text3,fontSize:12 }}>Waiting…</span>
              </div>
            </div>
          </div>
          <div style={{ width:230,borderLeft:`1px solid ${B.border2}`,display:"flex",flexDirection:"column" }}>
            <div style={{ padding:"10px 14px",borderBottom:`1px solid ${B.border2}`,color:B.text2,fontSize:10,letterSpacing:1.5,fontFamily:B.mono }}>LIVE TRANSCRIPT</div>
            <div style={{ flex:1,overflowY:"auto",padding:12,display:"flex",flexDirection:"column",gap:8 }}>
              {transcript.map((l,i)=>(
                <div key={i}>
                  <div style={{ color:B.violetLt,fontSize:10,marginBottom:2,fontFamily:B.mono }}>{l.speaker}</div>
                  <div style={{ color:"#ccc",fontSize:12,lineHeight:1.5 }}>{l.text}</div>
                  {l.translated&&<div style={{ color:B.text2,fontSize:11,fontStyle:"italic",marginTop:2,borderLeft:`2px solid ${B.violet}40`,paddingLeft:6 }}>{l.translated}</div>}
                </div>
              ))}
            </div>
            {recOn&&<div style={{ padding:"8px 14px",borderTop:`1px solid ${B.border2}`,display:"flex",alignItems:"center",gap:6 }}><div style={{ width:7,height:7,borderRadius:"50%",background:B.coral,animation:"pulse-dot 1s infinite" }}/><span style={{ color:B.coral,fontSize:10,fontFamily:B.mono }}>REC {fmt(recSecs)}</span></div>}
          </div>
        </div>
        <div style={{ display:"flex",alignItems:"center",justifyContent:"center",gap:8,padding:"12px 20px",borderTop:`1px solid ${B.border2}`,background:"rgba(8,7,15,0.6)" }}>
          <Ctrl icon={micOn?ICONS.mic:ICONS.micOff} label={micOn?"Mute":"Unmute"} active={micOn} onToggle={()=>setMicOn(v=>!v)} color={B.vibeGreen} />
          {call.type!=="voice"&&<Ctrl icon={camOn?ICONS.video:ICONS.videoOff} label={camOn?"Cam Off":"Cam On"} active={camOn} onToggle={()=>setCamOn(v=>!v)} color={B.sky} />}
          <Ctrl icon={ICONS.screen} label={screenOn?"Stop":"Share"} active={screenOn} onToggle={()=>setScreenOn(v=>!v)} color={B.purple} />
          <Ctrl icon={ICONS.record} label={recOn?"Stop Rec":"Record"} active={recOn} onToggle={()=>setRecOn(v=>!v)} color={B.coral} />
          <Ctrl icon={ICONS.download} label="Save" active={false} onToggle={()=>{}} color={B.amber} />
          <div style={{ width:1,height:36,background:B.border2,margin:"0 4px" }} />
          <button onClick={onClose} style={{ display:"flex",flexDirection:"column",alignItems:"center",gap:4,padding:"10px 22px",borderRadius:12,border:`1px solid ${B.coralBorder}`,background:B.coralDim,color:B.coral,fontFamily:B.font,fontSize:10,letterSpacing:0.4,cursor:"pointer" }}>
            <Ic d={ICONS.phoneOff} s={20} c={B.coral} />End Call
          </button>
        </div>
      </div>
    </div>
  );
}

// ── StreamModal ───────────────────────────────────────────────────────────────
export function StreamModal({ onClose }) {
  const { user }  = useAuthStore();
  const showToast = useUIStore(s=>s.showToast);
  const [isLive, setIsLive]  = useState(false);
  const [viewers,setViewers] = useState(0);
  const [micOn,  setMicOn]   = useState(true);
  const [camOn,  setCamOn]   = useState(true);
  const [recOn,  setRecOn]   = useState(false);
  const [transOn,setTransOn] = useState(false);
  const [transLang,setTransLang] = useState("Spanish");
  const [title,  setTitle]   = useState("My Vylapp Space");
  const [cat,    setCat]     = useState("General");
  const [secs,   setSecs]    = useState(0);
  const [chatInput,setChatInput] = useState("");
  const [messages, setMessages]  = useState([]);
  const chatRef = useRef(null);
  const chatMsgs = ["This is exactly what I needed 🙌","Can you share the slides?","Amazing community 💚","Joining from Lagos 🇳🇬","The AI integration part is 🤯"];
  const fakeUsers = [{displayName:"Aisha",initials:"AK",color:"#10F5A0"},{displayName:"Remi",initials:"RK",color:"#FF6B6B"},{displayName:"Leon",initials:"LC",color:"#38BDF8"}];

  useEffect(()=>{
    if(!isLive)return;
    const t1=setInterval(()=>setSecs(s=>s+1),1000);
    const t2=setInterval(()=>setViewers(v=>Math.max(0,v+Math.floor(Math.random()*4-1))),2000);
    const t3=setInterval(()=>{
      setMessages(prev=>[...prev.slice(-10),{user:fakeUsers[Math.floor(Math.random()*3)],text:chatMsgs[Math.floor(Math.random()*chatMsgs.length)]}]);
    },2500);
    return()=>{clearInterval(t1);clearInterval(t2);clearInterval(t3);};
  },[isLive]);

  useEffect(()=>{ if(chatRef.current)chatRef.current.scrollTop=chatRef.current.scrollHeight; },[messages]);

  const cats = ["General","Tech Vibes","Global Connect","Creative Learn","Human Potential","AgriTech","DAO Governance"];

  const sendChat=()=>{
    if(!chatInput.trim())return;
    setMessages(prev=>[...prev,{user:user||{displayName:"You",initials:"YO",color:"#7C3AED"},text:chatInput}]);
    setChatInput("");
    getSocket()?.emit("stream:chat",{streamId:"local",message:chatInput});
  };

  const goLive=()=>{
    setIsLive(v=>!v);
    if(!isLive){setViewers(Math.floor(Math.random()*500)+100);showToast("You're LIVE! 🔴","success");}
    else{setSecs(0);setViewers(0);}
  };

  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(8,7,15,0.92)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(24px)" }}>
      <div style={{ width:"min(960px,96vw)",background:B.bg2,borderRadius:20,border:`1px solid ${B.border}`,overflow:"hidden",boxShadow:`0 40px 120px rgba(124,58,237,0.25)` }}>
        <div style={{ height:2,background:B.gradCoral }} />
        <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 20px",borderBottom:`1px solid ${B.border2}` }}>
          <div style={{ display:"flex",alignItems:"center",gap:10 }}>
            <Ic d={ICONS.stream} s={16} c={B.coral} />
            <span style={{ color:B.text,fontWeight:700,fontSize:15 }}>Vylapp Live Space</span>
            {isLive&&<LiveBadge />}
          </div>
          <div style={{ display:"flex",alignItems:"center",gap:10 }}>
            {isLive&&<span style={{ color:B.vibeGreen,fontSize:14,fontFamily:B.mono }}>👁 {viewers.toLocaleString()} · {fmt(secs)}</span>}
            <TranslateToggle on={transOn} onToggle={()=>setTransOn(v=>!v)} lang={transLang} onLang={setTransLang} />
            <button onClick={onClose} style={{ background:"none",border:"none",cursor:"pointer",color:B.text2,padding:4,borderRadius:"50%" }}><Ic d={ICONS.close} s={18} c={B.text2} /></button>
          </div>
        </div>
        <div style={{ display:"flex",height:460 }}>
          <div style={{ flex:1,display:"flex",flexDirection:"column" }}>
            <div style={{ flex:1,background:`linear-gradient(135deg,${B.bg},#0f0c1f)`,position:"relative",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:16 }}>
              {user&&<Avatar user={user} size={84} ring />}
              <div style={{ textAlign:"center" }}>
                <div style={{ color:B.text,fontWeight:700,fontSize:17,maxWidth:300 }}>{title||"Vylapp Space"}</div>
                <div style={{ color:B.text2,fontSize:13,marginTop:4 }}>{cat} Space</div>
              </div>
              {isLive&&<>
                <div style={{ position:"absolute",top:12,left:12,display:"flex",gap:8 }}><LiveBadge />{recOn&&<span style={{ display:"inline-flex",alignItems:"center",gap:4,padding:"2px 8px",background:B.coralDim,borderRadius:4,color:B.coral,fontSize:11,fontWeight:700,border:`1px solid ${B.coralBorder}`,fontFamily:B.mono }}>● REC {fmt(secs)}</span>}</div>
                <div style={{ position:"absolute",top:12,right:12,padding:"4px 12px",background:"rgba(8,7,15,0.8)",borderRadius:8,border:`1px solid ${B.border2}` }}><span style={{ color:B.text,fontSize:13 }}>👁 {viewers.toLocaleString()}</span></div>
              </>}
              {transOn&&isLive&&<div style={{ position:"absolute",bottom:12,left:12,right:12,background:"rgba(8,7,15,0.92)",borderRadius:10,padding:"10px 14px",borderTop:`2px solid ${B.violet}` }}>
                <div style={{ color:B.text2,fontSize:10,letterSpacing:1,fontFamily:B.mono }}>LIVE CAPTIONS → {transLang}</div>
                <div style={{ color:B.violetLt,fontSize:14,marginTop:2 }}>"...el viaje de aprendizaje comienza aquí..."</div>
              </div>}
            </div>
            <div style={{ padding:"10px 14px",background:B.bg,display:"flex",alignItems:"center",gap:8 }}>
              <input value={title} onChange={e=>setTitle(e.target.value)} disabled={isLive} placeholder="Space title…"
                style={{ flex:1,background:B.bg3,border:`1px solid ${B.border2}`,borderRadius:9999,padding:"7px 14px",color:B.text,fontFamily:B.font,fontSize:13,outline:"none" }} />
              <select value={cat} onChange={e=>setCat(e.target.value)} disabled={isLive}
                style={{ background:B.bg3,border:`1px solid ${B.border2}`,borderRadius:8,padding:"7px 10px",color:B.text2,fontFamily:B.mono,fontSize:11,outline:"none" }}>
                {cats.map(c=><option key={c} value={c} style={{ background:B.bg3 }}>{c}</option>)}
              </select>
              {[{icon:micOn?ICONS.mic:ICONS.micOff,action:()=>setMicOn(v=>!v),active:micOn,c:B.vibeGreen},
                {icon:camOn?ICONS.video:ICONS.videoOff,action:()=>setCamOn(v=>!v),active:camOn,c:B.sky},
                {icon:ICONS.record,action:()=>setRecOn(v=>!v),active:recOn,c:B.coral}].map((b,i)=>(
                <button key={i} onClick={b.action} style={{ width:36,height:36,borderRadius:"50%",border:"none",cursor:"pointer",background:b.active?`${b.c}18`:"rgba(255,255,255,0.04)",display:"flex",alignItems:"center",justifyContent:"center" }}>
                  <Ic d={b.icon} s={16} c={b.active?b.c:B.text2} />
                </button>
              ))}
              <button onClick={goLive} style={{ padding:"8px 20px",borderRadius:9999,border:"none",cursor:"pointer",background:isLive?B.coralDim:B.grad,color:isLive?B.coral:"#fff",fontFamily:B.font,fontWeight:700,fontSize:14,boxShadow:isLive?"none":"0 4px 20px rgba(124,58,237,0.4)" }}>
                {isLive?"End Stream":"Go Live"}
              </button>
            </div>
          </div>
          <div style={{ width:270,borderLeft:`1px solid ${B.border2}`,display:"flex",flexDirection:"column" }}>
            <div style={{ padding:"10px 14px",borderBottom:`1px solid ${B.border2}`,color:B.text2,fontSize:10,letterSpacing:1.5,fontFamily:B.mono }}>LIVE CHAT</div>
            <div ref={chatRef} style={{ flex:1,overflowY:"auto",padding:12,display:"flex",flexDirection:"column",gap:8 }}>
              {messages.map((m,i)=>(
                <div key={i} style={{ display:"flex",gap:8,alignItems:"flex-start" }}>
                  <Avatar user={m.user} size={22} />
                  <div><span style={{ color:m.user.color,fontSize:12,fontWeight:700 }}>{m.user.displayName?.split(" ")[0]} </span><span style={{ color:"#ccc",fontSize:13 }}>{m.text}</span></div>
                </div>
              ))}
              {messages.length===0&&<div style={{ color:B.text3,fontSize:13,textAlign:"center",marginTop:20 }}>Chat will appear here when live…</div>}
            </div>
            <div style={{ padding:10,borderTop:`1px solid ${B.border2}` }}>
              <div style={{ display:"flex",gap:6 }}>
                <input value={chatInput} onChange={e=>setChatInput(e.target.value)} onKeyDown={e=>e.key==="Enter"&&sendChat()} placeholder="Vibe in the chat…"
                  style={{ flex:1,background:B.bg3,border:`1px solid ${B.border2}`,borderRadius:9999,padding:"7px 12px",color:B.text,fontFamily:B.font,fontSize:13,outline:"none" }} />
                <button onClick={sendChat} style={{ width:32,height:32,borderRadius:"50%",border:"none",cursor:"pointer",background:B.grad,display:"flex",alignItems:"center",justifyContent:"center" }}>
                  <Ic d={ICONS.send} s={14} c="#fff" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── IncomingCall ──────────────────────────────────────────────────────────────
export function IncomingCall({ call, onAccept, onDecline }) {
  return (
    <div style={{ position:"fixed",bottom:24,right:24,zIndex:900,background:B.bg2,borderRadius:18,padding:18,minWidth:300,border:`1px solid ${B.violetBorder}`,boxShadow:`0 24px 80px rgba(124,58,237,0.4)`,animation:"slide-up 0.3s ease" }}>
      <div style={{ height:2,background:B.grad,borderRadius:1,marginBottom:14 }} />
      <div style={{ display:"flex",alignItems:"center",gap:12,marginBottom:14 }}>
        <div style={{ position:"relative" }}>
          <Avatar user={call.user||{displayName:"Caller",initials:"CA",color:B.vibeGreen}} size={52} ring />
          <div style={{ position:"absolute",bottom:-2,right:-2,width:22,height:22,borderRadius:"50%",background:B.skyDim,border:`1.5px solid ${B.sky}40`,display:"flex",alignItems:"center",justifyContent:"center" }}>
            <Ic d={ICONS.video} s={11} c={B.sky} />
          </div>
        </div>
        <div style={{ flex:1 }}>
          <div style={{ fontWeight:700,fontSize:15,color:B.text }}>{call.user?.displayName||"Someone"}</div>
          <div style={{ color:B.text2,fontSize:13 }}>Incoming Vylapp {call.type} call…</div>
        </div>
        <div style={{ width:8,height:8,borderRadius:"50%",background:B.vibeGreen,animation:"pulse-dot 1s infinite",boxShadow:`0 0 8px ${B.vibeGreen}` }} />
      </div>
      <div style={{ display:"flex",gap:10 }}>
        <button onClick={onDecline} style={{ flex:1,padding:10,borderRadius:9999,border:`1px solid ${B.coralBorder}`,background:B.coralDim,color:B.coral,cursor:"pointer",fontFamily:B.font,fontWeight:700,fontSize:14,display:"flex",alignItems:"center",justifyContent:"center",gap:6 }}>
          <Ic d={ICONS.phoneOff} s={16} c={B.coral} /> Decline
        </button>
        <button onClick={onAccept} style={{ flex:1,padding:10,borderRadius:9999,border:"none",background:B.grad,color:"#fff",cursor:"pointer",fontFamily:B.font,fontWeight:700,fontSize:14,display:"flex",alignItems:"center",justifyContent:"center",gap:6,boxShadow:`0 4px 20px rgba(124,58,237,0.5)` }}>
          <Ic d={ICONS.video} s={16} c="#fff" /> Accept
        </button>
      </div>
    </div>
  );
}
